import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import '../shared/ui/base.css';
import { armarRedeDaCortina } from '../shared/ui/boot';
import { Providers } from './providers';
import { armarRecargaDeChunk } from '../shared/recarga-de-chunk';
import { rotas } from './router';

armarRedeDaCortina();

armarRecargaDeChunk();

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <Providers>
      <RouterProvider router={rotas} />
    </Providers>
  </StrictMode>,
);
